var React = require('react');

function FacebookColor (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.9","d":"M20.333 0.6875H3.14551C1.82715 0.6875 0.801758 1.76172 0.801758 3.03125V20.2188C0.801758 21.5371 1.82715 22.5625 3.14551 22.5625H9.83496V15.1406H6.75879V11.625H9.83496V8.98828C9.83496 5.96094 11.6416 4.25195 14.376 4.25195C15.7432 4.25195 17.1104 4.49609 17.1104 4.49609V7.47461H15.5967C14.083 7.47461 13.5947 8.40234 13.5947 9.37891V11.625H16.9639L16.4268 15.1406H13.5947V22.5625H20.333C21.6025 22.5625 22.6768 21.5371 22.6768 20.2188V3.03125C22.6768 1.76172 21.6025 0.6875 20.333 0.6875Z","fill":"#FFBB4E"}));
}

FacebookColor.defaultProps = {"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none"};

module.exports = FacebookColor;

FacebookColor.default = FacebookColor;
